import React from 'react';
import { Row, Col } from 'antd';
import foodImage1 from '../../assets/images/food/food-1.jpeg';
import foodImage2 from '../../assets/images/food/food-2.jpeg';
import foodImage3 from '../../assets/images/food/food-3.jpeg';
import foodImage4 from '../../assets/images/food/food-4.jpeg';

import PastOrdersItemCard from './PastOrdersItemCard';

const foodList = [
  {
    key: '1',
    cover: foodImage1,
    resurantName: 'Food Den',
    deliveryDateTime: '09-06-2020 9:20 AM',
    itemName: 'Pastry',
    quantity: 1
  },
  {
    key: '2',
    cover: foodImage2,
    resurantName: 'Food Den',
    deliveryDateTime: '09-06-2020 9:20 AM',
    itemName: 'Egg Rice',
    quantity: 4
  },
  {
    key: '3',
    cover: foodImage3,
    resurantName: 'Food Den',
    deliveryDateTime: '09-06-2020 9:20 AM',
    itemName: 'Potatao Chilli',
    quantity: 2
  },
  {
    key: '4',
    cover: foodImage4,
    resurantName: 'Food Den',
    deliveryDateTime: '09-06-2020 9:20 AM',
    itemName: 'Chocos dark icecream',
    quantity: 2
  }
];

const PastOrders: React.FC = (Props: any) => {
  return (
    <Row gutter={[16, 24]}>
      {foodList.map((item) => (
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} key={item.key}>
          <PastOrdersItemCard item={item} />
        </Col>
      ))}
    </Row>
  );
};

export default PastOrders;
